export default __webpack_public_path__ + "static/media/REL-DIN-30A.a8649da8.png";